// extracted by mini-css-extract-plugin
export default {"dashboardDemo":"demo-dashboard_dashboardDemo__fzfjt","dashboardContainer":"demo-dashboard_dashboardContainer__HVo4I"};